import React from 'react';
import useTabParam from '../../hooks/useTabParam';
import { Box } from '@mui/material';
import { TabContext, TabList, TabPanel } from '@mui/lab';
import { Tab } from '@mui/material';
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';
import MoneyOffIcon from '@mui/icons-material/MoneyOff';
import CODRemittance from './CODRemittance';

function CODRemittanceTabs() {
    const [value, setValue] = useTabParam('1');

    const handleChange = (_event, newValue) => {
        setValue(newValue);
    };

    return (
        <TabContext value={value}>
            <Box sx={{ backgroundColor: '#fff', boxShadow: 1 }}>
                <TabList
                    onChange={handleChange}
                    indicatorColor="primary"
                    textColor="primary"
                    sx={{
                        '& .MuiTab-root': {
                            px: 4,
                            py: 1.5,
                            fontWeight: 500,
                        },
                    }}
                >
                    <Tab icon={<CurrencyRupeeIcon />} iconPosition="start" label="COD Remittance with COD Amount" value="1" />
                    <Tab icon={<MoneyOffIcon />} iconPosition="start" label="COD Remittance without COD Amount" value="2" />
                </TabList>
            </Box>
            <TabPanel value="1" sx={{ px: 0 }}>
                <CODRemittance type='NonNull' />
            </TabPanel>
            <TabPanel value="2" sx={{ px: 0 }}>
                <CODRemittance type='Null' />
            </TabPanel>
        </TabContext>
    );
}

export default CODRemittanceTabs;
